export default __webpack_public_path__ + "static/media/straight-award.ba7a2ef2.png";